<annotated-control [field]="field">
  <k2-select
    [(value)]="value"
    [options]="options"
    [disabled]="disabled"
    [multiple]="multiple"
  ></k2-select>
</annotated-control>
